export const API: any = {
  DEV: () => 'https://d30z26oy7p4kbi.cloudfront.net',
  STAGGING: () => 'https://d30z26oy7p4kbi.cloudfront.net',
  PROD: () => 'https://d2pz7ux2nyxq6x.cloudfront.net',
  PREVIEW: () => 'https://d30z26oy7p4kbi.cloudfront.net',
}

export const VERSION = () => import.meta.env.VITE_VERSION || 'v2.430.2-main(6694406)'
export const ENV = () => {
  const env = () => import.meta.env.VITE_ENV || 'PROD' // DEV PROD STAGGING PREVIEW
  return env().includes('ENV') ? 'DEV' : env()
}
